// extracted by mini-css-extract-plugin
export default {"filtersContainer":"group-filters_filtersContainer__q-835","dropdownContainer":"group-filters_dropdownContainer__QuEdD","marginRight10":"group-filters_marginRight10__srA1U"};